import { Controller } from "@hotwired/stimulus";
export default class RoomController extends Controller {
  static targets = ["chatBox", "reactEmoji"];

  scroll() {
    setTimeout(() => {
      const chatBox = document.getElementById("chat-history");
      chatBox.scrollTop = chatBox.scrollHeight;
    }, 100);
  }

  connect() {
    globalThis.skipPopstate = true;
    this.displayRoom();
    this.positionInitialMessages();
  }

  // toggle the emoji react icon hide/unhide based on broadcast dataset value
  reactEmojiTargetConnected() {
    if (this.hasReactEmojiTarget) {
      const canReact = this.reactEmojiTarget.dataset.reactValue === "true";

      for (const element of this.element.querySelectorAll(".message-emoji")) {
        element.classList.toggle("d-none", !canReact);
      }
    }
  }

  positionInitialMessages() {
    const messages = document.getElementById("chat-history");
    if (!messages) return;

    const skeleton = this.element.querySelector(".chat-positioning-skeleton");

    const moveToBottom = () => {
      messages.scrollTop = messages.scrollHeight - messages.clientHeight;

    };

    // Position immediately, then once more after the browser has completed
    // layout. Keep message rows hidden until the final position is committed
    // so the oldest rows at the top cannot flash for a frame.
    moveToBottom();
    requestAnimationFrame(() => {
      moveToBottom();
      requestAnimationFrame(() => {
        moveToBottom();
        this.element.classList.remove("chat-initial-positioning");
        skeleton?.remove();
      });
    });
  }

  displayRoom() {
    const userList = document.getElementById("user-list");
    const chatArea = document.getElementById("chat-area");
    const headerBackBtn = document.getElementById("header-back-btn");
    if (globalThis.innerWidth < 1399 && (chatArea && userList)) {
      userList?.classList?.add("d-none");
      chatArea?.classList?.remove("d-none");
      chatArea?.classList?.add("d-flex");
      headerBackBtn?.classList?.add("d-none");
    }
  }

  hideButtons() {
    $(".reply-btn").addClass("d-none");
  }

  showButtons() {
    $(".reply-btn").removeClass("d-none");
  }

  backClick(event) {
    event.preventDefault();

    if (globalThis.history.length > 1) {
      globalThis.history.back();
    } else {
      globalThis.location.href = '/messages';
    }
  }

  removePopStateListener() {
    if (this.popStateHandler) {
      globalThis.removeEventListener("popstate", this.popStateHandler);
      this.popStateHandler = null;
    }
  }
}
